module.exports = __webpack_public_path__ + "assets/img/game-images-loader.eeb4211b.svg";